import { ComponentPublicInstance } from "vue";
import axios from "axios";
import Utility from "./UtilityFunctions";

const logMsg = (data: any) => {
  axios
    .post(Utility.constants().API.error_log, data)
    .then(() => {})
    .catch(() => false);
};

declare global {
  interface Window {
    userId: string;
    CONSTANT: {
      API: {
        error_log: string;
      };
    };
  }
}

// Vue component life cycle errors
export function errorHandler(err: unknown, vm: ComponentPublicInstance | null, info: string) {
  let errorMessage: string;
  if (err instanceof Error) {
    errorMessage = err.message;
  } else {
    errorMessage = String(err);
  }
  
  const data = Utility.createFrontendErrorLogData(
    'Error',
    window?.userId,
    errorMessage,
    vm?.$options?.name,
    info,
    window.location.href
  );
  logMsg(data);
  console.error(err);
};

// Vue component life cycle warnings - should only be used during development
// export function warnHandler(msg: string, vm: ComponentPublicInstance | null, trace: string) {
//   console.log('Warning: ' + { msg });
//   console.log(msg);
//   const data = Utility.createFrontendErrorLogData(
//     'Warning',
//     window?.userId,
//     msg,
//     vm?.$options?.name,
//     trace,
//     window.location.href
//   );
//   logMsg(data);
// };